import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45d3a06a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-image" }
const _hoisted_2 = ["alt"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = { class: "outer-sphere" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "brand-store"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.kilimall.com/kenya/new_wap/goods/brand_official.png",
  alt: ""
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "standard" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_rate = _resolveComponent("van-rate")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", {
    class: "page-goods-list",
    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.unifiedJump($setup.item)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("img", {
        alt: $props.data.name
      }, null, 8, _hoisted_2), [
        [_directive_lazy, _ctx.webpFilters($setup.item.images.L)]
      ]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("h3", {
        class: "goods-name",
        innerHTML: $props.data.name
      }, null, 8, _hoisted_6),
      _createElementVNode("div", {
        class: _normalizeClass(["goods-price", {'goods-price-pri': parseInt($setup.item.price_gray).thousands().length>5}])
      }, [
        _createElementVNode("p", null, [
          _createElementVNode("b", null, _toDisplayString($setup.currencyUnit), 1),
          _createTextVNode(" " + _toDisplayString(parseInt($setup.item.price).thousands()), 1)
        ]),
        _createElementVNode("span", null, [
          _createElementVNode("span", null, _toDisplayString($setup.currencyUnit) + " ", 1),
          _createTextVNode(" " + _toDisplayString(parseInt($setup.item.price_gray).thousands()), 1)
        ])
      ], 2),
      ($props.brandStoreShow && $setup.item.tags.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_van_rate, {
          modelValue: $setup.item.rate,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.item.rate) = $event)),
          "allow-half": "",
          "void-icon": "star",
          size: 12,
          color: "#F9BE00",
          "void-color": "#eee"
        }, null, 8, ["modelValue"]),
        _createElementVNode("span", null, "(" + _toDisplayString($setup.item.ratings ? $setup.item.ratings : 0) + ")", 1)
      ])
    ])
  ]))
}